import { Component, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CheckableSettings } from "@progress/kendo-angular-treeview";
import { TreeViewFilterSettings } from "@progress/kendo-angular-treeview";
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { Family, Question, SupplierKnowledgeParameters, SupplierFamily, SimpleReponseResult, SupplierAnswer, SaveStepParam } from '../../../all-models';
import { AbstractControl, NgForm } from '@angular/forms';
import { AccidentologieComponent } from '../../../COMPOSANTS/accidentologie/accidentologie.component';
import { SharedDataService, SuppliersService, PafListsService, DocumentsService, ContactsService } from '../../../all-services';
import { SupplierDetailsStepBase, checkValidityEvent } from '../supplier-details/suppliers-details-step-base';
import { searchIcon, SVGIcon } from '@progress/kendo-svg-icons';
import moment from 'moment';
import { IconComponent } from '@progress/kendo-angular-icons';


@Component({
  selector: 'app-supplier-knowledge',
  templateUrl: './supplier-knowledge.component.html',
  styleUrls: ['./supplier-knowledge.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SupplierKnowledgeComponent extends SupplierDetailsStepBase
  implements OnChanges {

  @ViewChild('ngFrmsupplierknowledge') frmsupplierknowledge: NgForm;
  public lstFamilies: Family[] = [];//Liste de l'ensemble des familles
  public parsedFamilies: Family[] = []; // listes des familles affichées après filtre
  public segments: any[] = [];
  public FamiliesLimit: number = 30;
  @ViewChild('accComponent') accidentologie: AccidentologieComponent;
  public selectedSupplierFamilies: SupplierFamily[] = [];
  public mainSupplierFamily: SupplierFamily = new SupplierFamily();
  public familyFilter: string = '';
  public lstQuestions: Question[] = [];
  //Liste des questions visibles pour le fournisseur selon son pays,sa forme legale et ses familles selectionnées (rechargée dynamiquement à chaque mise à jour des familles sélectionnées)
  public visibleQuestions: Question[] = [];
  public firstLevelQuestions: Question[] = [];
  public expandedFamilyIds: any[] = [];
  public searchIcon : SVGIcon = searchIcon;

  public iconComponent : IconComponent;
  public treeviewFilterSettings: TreeViewFilterSettings = {
    operator: 'contains',
    ignoreCase: true
  }
  get checkableSettings(): CheckableSettings {
    return {
      checkChildren: false,
      checkParents: false,
      //enabled: !this.readonly,
      mode: 'multiple',
      checkOnClick: false
    };
  }


  constructor(
    public route: ActivatedRoute,
    public suppliersSvc: SuppliersService,
    public sharedDatasSvc: SharedDataService,
    public docsSvc: DocumentsService,
    private pafLists: PafListsService,
    public contactsSvc: ContactsService) {
    super(sharedDatasSvc, docsSvc, suppliersSvc, route, contactsSvc);
  }

  getFamiliesCallBack(res: Family[]): void {
    res.sortObject('Cod');
    this.expandedFamilyIds = [];
    this.lstFamilies = res;
    this.segments = [];
    res.filter(n => n.ParentId == null).forEach(n => {
      if (!this.segments.some(s => s.node.Cod == n.Cod)) {
        let segment: any = {
          'node': n,
          'checked': false
        };
        this.segments.push(segment);
      }
    });
    this.checkedIds = this.supplier.SupplierFamilies.map((f: SupplierFamily) => f.FamilyId);
    this.expandedFamilyIds = [];
    setTimeout((): void => {
      this.selectSegmentFromSelectedFamilies();
      this.parseDatas(res);
    });
  };

  showErrorsCallback(value:boolean) : void {
    Object.keys(this.frmsupplierknowledge.controls)
      .forEach((key, i) => {
        let control: AbstractControl = this.frmsupplierknowledge.controls[key];
        control.markAsTouched();
      });
  };

  loadAllObservables(): Observable<void> {
    let tmpSubject: Subject<void> = new Subject<void>();
    this.sharedDatasSvc.WindowLock();
    forkJoin([
      this.pafLists.getFamilies(),
      this.pafLists.getQuestions()
    ]).subscribe({
      next: results => {
        this.getFamiliesCallBack(results[0]);
        this.lstQuestions = results[1];
        this.updateVisibleQuestions()
          .subscribe({
            next: () => tmpSubject.next(),
            error: (error: any) => tmpSubject.error(error)
          });
      },
      error: (error: any) => {
        tmpSubject.error(error);
      }
    });
    return tmpSubject.asObservable();
  }

  ngOnInit(): void {
    this.showErrors.subscribe(res => this.showErrorsCallback(res));
    this.sharedDatasSvc.WindowLock();
    this.loadAllObservables()
      .subscribe({
        next: res => this.sharedDatasSvc.WindowUnlock(),
        error: (err: any) => this.sharedDatasSvc.alert(err.error || err)
      }
      );
  }

  get displayedSegments(): any[] {
    return this.segments.filter(item => item.node?.Cod != '99000000');
  }
  segmentNodeIsDisable(item: any) {
    if (item.node?.Cod == '99000000') {
      if (this.isEditing() && item.checked) item.checked = false;
      return true;
    }
    return this.domaineActiviteDisabled || !this.isEditing();
  }

  private updateFirstLevelQuestions(): void {
    //Les questions de bases sont celles qui ne sont pas référencées par une autre question.
    this.firstLevelQuestions = this.lstQuestions.filter(q => this.visibleQuestions.some(q2 => q2.Id == q.Id)
      && !this.lstQuestions.some(q2 => q2.IdTrueQuestion == q.Id || q2.IdFalseQuestion == q.Id));
    this.firstLevelQuestions.sortObject('QuestionRank');
    this._CompleteSupplierAnswers();

  }


  selectSegmentFromSelectedFamilies(): void {
    if (this.selectedSupplierFamilies.length > 0 && this.segments.length > 0) {
      this.segments.forEach((s: any) => {
        s.checked = this.selectedSupplierFamilies.some(sf => sf.FamilyId == s.node.Id);
      })
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes['supplier']) {
      if (this.supplier) {
        if (this.supplier.SupplierFamilies.some((sf: SupplierFamily) => sf.MainFamily == 1)) {
          this.mainSupplierFamily = this.supplier.SupplierFamilies.find((sf: SupplierFamily) => sf.MainFamily == 1);
          this._CompleteSupplierAnswers();
        } else {
          this.mainSupplierFamily = new SupplierFamily();
        }
      }
    }
    if (changes['ocurrentstep']) {
      setTimeout(() => {
        this.ocurrentstep.showSaveButton = (): boolean => { return this._ShowSaveButton() };
      }, 0);
      this.ocurrentstep.supplierReloaded.subscribe((id: number) => {
        this.checkedIds = this.supplier.SupplierFamilies.map((f: SupplierFamily) => f.FamilyId);
        this.updateselectedFamilies().subscribe();
      });
    }
  }
  private _ShowSaveButton = (): any => {
    if (!this.canModifySupplier()) return false;
    return !(this.domaineActiviteDisabled && this.specificitesDisabled && this.accidentologieDisabled);
  }
  get domaineActiviteDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    //return (['ACH_OPERAT', 'ACH_FAMHA', 'CTRL_QUAL', 'ADMIN'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0);
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_DOMAINE_ACTIVITE');
  }

  get specificitesDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    //return (['ACH_OPERAT', 'ACH_FAMHA', 'CTRL_QUAL', 'ADMIN', 'FOURNISSEUR'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0);
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_SPECIFICITES');  
  }

  get accidentologieDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    //return (['ACH_OPERAT', 'ACH_FAMHA', 'CTRL_QUAL', '3SE', 'QUAL', 'ADMIN', 'FOURNISSEUR'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0);
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_ACCIDENTOLOGIE');  
  }
  private _CompleteSupplierAnswers(): void {
    if (!this.supplier || this.lstQuestions.length == 0) return;
    let tmpSupplierAnswers: SupplierAnswer[] = [];
    this.lstQuestions.forEach(q => {
      if (this.supplier.SupplierAnswers.some(sa => sa.QuestionId == q.Id)) {
        tmpSupplierAnswers.push(this.supplier.SupplierAnswers.find(sa => sa.QuestionId == q.Id));
      } else {
        let sa: SupplierAnswer = new SupplierAnswer();
        sa.SupplierId = this.supplier.Id;
        sa.QuestionId = q.Id;
        sa.Question = q;
        sa.Answer = null;
        tmpSupplierAnswers.push(sa);
      }
    });
    this.supplier.SupplierAnswers = tmpSupplierAnswers;
  }


  private _checkedIds: number[] = [];
  public get checkedIds(): number[] {
    return this._checkedIds;
  }
  public set checkedIds(values: number[]) {
    this._checkedIds = values;
    this.updateselectedFamilies().subscribe();
  }


  public familyLevel(familyId: number): number {
    return this.pafLists.familyLevel(familyId, this.lstFamilies);
  }

  public familyNodeLabel(familyId: number): string {
    return (this.pafLists.familyLabel(familyId, this.lstFamilies));
  }


  get TopWorkAtClient(): boolean {
    return this.supplier.TopWorkAtClient == 1;
  }
  set TopWorkAtClient(value: boolean) {
    this.supplier.TopWorkAtClient = value ? 1 : 0;

  }

  public PrestationTravauxSel(): boolean {
    return this.selectedSupplierFamilies.some((node: SupplierFamily) => node.Family?.Cod == '01000000');
  }
  public RessourcesHumainesSel(): boolean {
    return this.selectedSupplierFamilies.some((node: SupplierFamily) => node.Family?.Cod == '40000000');
  }


  lstRootNodes(list?: Family[]): Family[] {
    if (!this.familyFilter) {
      return this.segments.filter(s => s.checked).map(s => s.node);
    } else {
      return (list || []).filter(f => (f.ParentId || 0) == 0);
    }
  }

  public parseDatas(flatListe: Family[], fromNode?: any) {

    if (fromNode == null) {
      this.parsedFamilies = [];
      this.expandedFamilyIds = [];
      this.lstRootNodes(flatListe).forEach((family: Family) => {
        let clone: any = Object.assign({}, family);
        clone['Children'] = [];
        clone['Level'] = 0;
        clone['checkable'] = false;
        clone['checked'] = false;
        clone['isExpanded'] = true;
        this.expandedFamilyIds.push(clone.Id);
        this.parsedFamilies.push(clone);
        this.parseDatas(flatListe, clone);
      });
    } else {
      flatListe.filter(f => f.ParentId == fromNode.Id)
        .forEach((family: Family) => {
          let clone: any = Object.assign({}, family);
          clone['Children'] = [];
          clone['Level'] = fromNode.Level + 1;
          clone['checkable'] = true;
          clone['checked'] = this.checkedIds.some(id => id == family.Id);
          if (fromNode.Level == 0) this.expandedFamilyIds.push(clone.Id);
          clone['isExpanded'] = (fromNode.Level == 0);
          fromNode.Children.push(clone);
          this.parseDatas(flatListe, clone);
        });
    }
  }

  public isFamilyNodeExpanded = (dataItem: any, index: string) => {
    return dataItem.Level <= 1 && dataItem.isExpanded;
  };


  rootNode(familyId: number): Family {
    let node = this.lstFamilies.find(f => f.Id == familyId);
    if (!node) return null;
    if (!node.ParentId) return node;
    return this.rootNode(node.ParentId);
  }

  parentNode(node: Family): Family {
    return this.lstFamilies.find(n => n.Id == node?.ParentId);
  }

  public parsedFamilieshasChildren = (item: any): boolean => {
    return item.Children.length > 0;
  }

  public parsedFamiliesFetchChildren = (item: any): Observable<any[]> => {
    return of(item.Children);
  }

  public getSelectedChildren(supplierNodeId: number): SupplierFamily[] {
    return this.selectedSupplierFamilies.filter(n => n.Family?.ParentId == supplierNodeId);
  }

  public iconClass = (node: Family) => {
    return this.pafLists.familyIcon(node.Id, this.lstFamilies);
  }
  
  public nodeClass = (nodeId: number, selected : boolean = false) => {
    return this.pafLists.familyClass(nodeId, this.lstFamilies, selected);
  }
  
  public selectedableDropDownNodeClass = (nodeId: number, selected : boolean = false) => {
    return this.pafLists.familyClass(nodeId, this.lstFamilies, selected);
  }
  public nodeClassIcon = (nodeId: number) => {
    return this.pafLists.familyIconClass(nodeId, this.lstFamilies);
  }


  public collapseiconClass = (node: Family) => {
    if (!this.parsedFamilieshasChildren(node)) return "";
    return {
      "pointer text-primary k-icon": true,
      "k-i-plus-sm": !this.isFamilyExpanded(node, null),
      "k-i-minus-sm": this.isFamilyExpanded(node, null),
      "custom-tree-icon-check": node.ParentId != null,
      "custom-tree-icon-nocheck": node.ParentId == null
    };
  }


  public toggleCollapse(node: Family): void {
    if (this.isFamilyExpanded(node, null)) {
      this.expandedFamilyIds = this.expandedFamilyIds.filter(c => c != node.Id);
    } else {
      this.expandedFamilyIds.push(node.Id);
    }
  }


  familyFilterChange(value: string): void {
    this.familyFilter = value;
    this.reloadTree();
  }

  reloadTree(): void {
    this.expandedFamilyIds = [];
    if ((this.familyFilter || '') == '') {
      this.parseDatas(this.lstFamilies);
    } else {
      const flatFilteredFamilies: Family[] = this.search(this.lstFamilies, this.familyFilter);
      flatFilteredFamilies.filter(f => this.familyLevel(f.Id) == 2)
        .forEach((childF: Family) => {
          if (!flatFilteredFamilies.some(f => f.Id == childF.ParentId)) {
            var cloneFamily: Family = Object.assign({}, this.lstFamilies.find(f => f.Id == childF.ParentId));
            flatFilteredFamilies.splice(flatFilteredFamilies.indexOf(childF), 0, cloneFamily);
          }
        });
      flatFilteredFamilies.filter(f => this.familyLevel(f.Id) == 1)
        .forEach((childF: Family) => {
          if (!flatFilteredFamilies.some(f => f.Id == childF.ParentId)) {
            var cloneFamily: Family = Object.assign({}, this.lstFamilies.find(f => f.Id == childF.ParentId));
            flatFilteredFamilies.splice(flatFilteredFamilies.indexOf(childF), 0, cloneFamily);
          }
        });
      this.parseDatas(flatFilteredFamilies);
    }
  }

  public search(items: Family[], term: string): any[] {
    let result: Family[] = [];
    items.forEach((family, i) => {
      if (this.familyNodeMatchSearch(term, family)) {
        let clone: Family = Object.assign({}, family);
        result.push(clone);
      }
    });
    return result;
  }

  public familyNodeMatchSearch(term: String, node: Family): boolean {
    return this.familyNodeLabel(node.Id).toLowerCase().removeAccents().indexOf((term || "").toLowerCase().removeAccents()) >= 0;
  }

  public contains(text: string, term: string): boolean {
    if ((term || '') == '') return true;
    return text.toLowerCase().removeAccents().indexOf((term || "").toLowerCase().removeAccents()) >= 0;
  }

  public isFamilyExpanded = (dataItem: any, index: string) => {
    return this.expandedFamilyIds.indexOf(dataItem.Id) > -1;
  };

  public isExpandedSelection = (dataItem: any, index: string) => {
    return true;
  };


  public getChildren(nodeId: number, lst: any): any {
    if (!lst) {
      return [];
    } else {
      return lst.filter((n: any) => n.ParentId == nodeId);
    }
  }

  public isFamilyChecked = (dataItem: object, index: string) => {
    const family: Family = <Family>dataItem;
    if (this.familyLevel(family.Id) == 1 && this.getSelectedChildren(family.Id).length > 0) {
      let nbChildren: number = this.getChildren(family.Id, this.selectedSupplierFamilies).filter((n: any) => this.isFamilyChecked(n, null) == "checked").length;
      if (nbChildren > 0) {
        if (this.checkedIds.indexOf(family.Id) < 0) this.checkedIds.push(family.Id);
        return "checked";
      }
    }
    return this.checkedIds.indexOf(family.Id) > -1 ? "checked" : "none";
  };


  public getHighlightText(item: Family): string {
    const nodeLabel = this.familyNodeLabel(item.Id);
    if (this.familyFilter == '' || !this.contains(nodeLabel, this.familyFilter)) {
      return nodeLabel;
    } else {
      var startIndex = nodeLabel.toLowerCase().removeAccents().indexOf(this.familyFilter.toLowerCase().removeAccents());
      var endIndex = startIndex + this.familyFilter.length;
      return [
        nodeLabel.slice(0, startIndex),
        '<mark>',
        nodeLabel.slice(startIndex, endIndex),
        '</mark>',
        nodeLabel.slice(endIndex)
      ].join('');
    }
  }


  //On parcourt les noeuds sélectionnés de niveau 1 et 2 en ajoutant les noeuds de niveau 0 pour l'affichage
  //Quand on coche un niveau 2, le noeud parent doit être obligatoirement sélectionné
  updateselectedFamilies(): Observable<void> {
    let families: Family[] = [];
    let selectedNodes: Family[] = this.lstFamilies.filter((n: Family) => this.checkedIds.indexOf(n.Id) >= 0);
    let selectedNodes1: Family[] = selectedNodes.filter((n: Family) => this.familyLevel(n.Id) == 1);
    let selectedNodes2: Family[] = selectedNodes.filter((n: Family) => this.familyLevel(n.Id) == 2);
    //On ajoute les noeuds de rang 1 manquants si des fils de rang 2 sont sélectionnés
    selectedNodes2.filter((n2: Family) => !selectedNodes1.find(n1 => n1.Id == n2.ParentId))
      .forEach((n3: Family) => {
        const ntmp: Family = this.lstFamilies.find(n => n.Id == n3.ParentId);
        this.checkedIds.push(ntmp.Id);
        selectedNodes1.push(ntmp);
      });
    selectedNodes2.sortObject('SubFamilyCod');
    selectedNodes1.sortObject('FamilyCod');
    let rootNodes: Family[] = this.lstFamilies.filter(rootNode => rootNode.ParentId == null && selectedNodes1.some(n1 => n1.ParentId == rootNode.Id));
    rootNodes.sortObject('Segment');
    rootNodes.forEach(rootNode => {
      let segmentNode: Family = Object.assign({}, rootNode);
      families.push(segmentNode);
      selectedNodes1.filter(n1 => n1.ParentId == segmentNode.Id).forEach(parChild1 => {
        if (!families.some((item: Family) => item.Id == parChild1.Id)) {
          let child1 = Object.assign({}, parChild1);
          families.push(child1);
          selectedNodes2.filter(n2 => n2.ParentId == child1.Id).forEach(parChild2 => {
            if (!families.some((item: Family) => item.Id == parChild2.Id)) {
              let child2 = Object.assign({}, parChild2);
              families.push(child2);
            }
          });
        }
      });
    });
    this.selectedSupplierFamilies = families
      .map((f: Family) => {
        let sf = new SupplierFamily();
        sf.SupplierId = this.supplier.Id;
        sf.FamilyId = f.Id;
        sf.Family = f;
        sf.MainFamily = (this.mainSupplierFamily?.FamilyId == f.Id ? 1 : 0)
        return sf;
      });
    if (this.mainSupplierFamily && !this.selectedSupplierFamilies.some(item => item.FamilyId == this.mainSupplierFamily.FamilyId)) {
      this.mainSupplierFamily = new SupplierFamily();
    };
    return this.updateVisibleQuestions();
  }


  updateVisibleQuestions(): Observable<void> {
    let tmpSubject :Subject<void> =  new Subject<void>(); 
    let selectedFamiliesId: number[] = [];
    if (this.selectedSupplierFamilies) selectedFamiliesId = this.selectedSupplierFamilies.map(sf => sf.FamilyId);
    this.suppliersSvc.postVisibleQuestions(this.supplier?.Id, selectedFamiliesId)
      .subscribe(res => {
        this.visibleQuestions = res;
        this.updateFirstLevelQuestions();
        tmpSubject.next();
      });
      return tmpSubject.asObservable();
  }

  get mainFamilyData(): SupplierFamily[] {
    return this.selectedSupplierFamilies.filter((sf: SupplierFamily) => this.lstFamilies.some(f => f.Id == sf.FamilyId && f.ParentId != null));
  }

  public flatDropDownDisplay(familyId: number): string {
    let node: Family = this.lstFamilies.find(f => f.Id == familyId);
    if (!node) return '';
    return node.Segment
      + ((node.FamilyCod || 'null') == 'null' ? '' : (' / ' + node.FamilyCod))
      + ((node.SubFamilyCod || 'null') == 'null' ? '' : (' / ' + node.SubFamilyCod));
  }


  public segmentsDebug(): any[] {
    return this.segments.map((n: any) => {
      return {
        'segment': n.node.NodeLabel,
        'checked': n.checked
      }
    });
  }

  public FamiliesTooManySel(): boolean {
    return this.checkedIds.length > this.FamiliesLimit;
  }


  save(param: SaveStepParam): void {
    if (param.nextAction == 'forceScreen') {
      this.CanSave(this.frmsupplierknowledge, param);
      super.save(param);
      return;
    }
    this.CanSave(this.frmsupplierknowledge, param);
    if (param.canSave && this.accidentologie) {
      this.CanSave(this.accidentologie.frmAcc, param)
    }

    let parameters: SupplierKnowledgeParameters = new SupplierKnowledgeParameters();
    Object.keys(parameters).forEach((key, index) => {
      (<any>parameters)[key] = (<any>this.supplier)[key];
    });
    parameters.SupplierFamilies = this.mainFamilyData;
    //Changement de règle : Il faut à minima 1 compétence du référentiel pour pourvoir gérer les doc dispo par la suite
    if (parameters.SupplierFamilies.length == 0) {
      param.canSave = false;
      if (!param.noSaveAllowed(this.currentStep)) {
        this.sharedDatasSvc.pafAlert('Msg_Family_missing');
        return;
      }
    }
    if (this.mainSupplierFamily != null) {
      parameters.SupplierFamilies.forEach(sf => sf.MainFamily = (sf.FamilyId == this.mainSupplierFamily.FamilyId ? 1 : 0));
    }
    if (parameters.SupplierFamilies.length > 0) {
      if (parameters.SupplierFamilies.length == 1) parameters.SupplierFamilies[0].MainFamily = 1;
      if (!parameters.SupplierFamilies.find((sf: SupplierFamily) => sf.MainFamily == 1)) {
        param.canSave = false;
        if (!param.noSaveAllowed(this.currentStep)) {
          this.sharedDatasSvc.pafAlert('Msg_Preciser_coeur_de_metier');
          return;
        }
      }
    }


    parameters.SupplierAnswers = parameters.SupplierAnswers.filter(a => this.visibleQuestions.some(vQuestion => vQuestion.Id == a.QuestionId));

    parameters.SupplierAnswers.forEach(a => a.SupplierId = this.supplier.Id);
    if (!this.checkAnswerComplete(parameters)) {
      param.canSave = false;
      if (!param.noSaveAllowed(this.currentStep)) {
        this.sharedDatasSvc.pafAlert('Msg_Completer_Specificites');
        return;
      }
    }
    parameters.SupplierAnswers = parameters.SupplierAnswers.filter(a => a.Answer != null);

    if (!this.showAccidentologie) {
      parameters.AccDatDeb = null;
      parameters.AccDatFin = null;
      parameters.NbEmployees = null;
      parameters.NbWorkHours = null;
      parameters.NbWorkAccLostDays = null;
      parameters.NbWorkAccStop = null;
      parameters.NbWorkAccNoStop = null;
      parameters.TG = null;
      parameters.TF1 = null;
      parameters.TF2 = null;
    } else  {
      parameters.AccDatDeb = moment(parameters.AccDatDeb).utcOffset(0, true).toDate();
      parameters.AccDatFin = moment(parameters.AccDatFin).utcOffset(0, true).toDate();
    }

    if (!param.canSave) {
      if (param.noSaveAllowed(this.currentStep)) {
        this.msgEcranIncomplet.subscribe(msg=>{
          this.sharedDatasSvc.confirm(msg, (): void => super.save(param), null);
        })
      }
      return;
    }

    this.suppliersSvc.patchSupplierKnowledge(this.supplier.Id, parameters)
      .subscribe((res: SimpleReponseResult) => {
        if (res.Ok) {
          super.save(param);
        } else {
          this.sharedDatasSvc.alert(res.Message);
        }
      });
  }

  onCheckValidity(event:checkValidityEvent):Observable<boolean | undefined>{
    if (event.stepNum!=this.screenValidity.step) return of(undefined);
    event.forms = [this.frmsupplierknowledge];
    if (this.showAccidentologie) event.forms.push(this.accidentologie.frmAcc);
    let isValid: boolean = true; 
    if (this.mainFamilyData.length==0) {
      this.ocurrentstep.screenValidity.errorMessages.push('Msg_Family_missing');
      isValid=false;
    }
    if (this.mainSupplierFamily == null) {
      this.screenValidity.errorMessages.push('Msg_Preciser_coeur_de_metier');
      isValid=false;
    }
    if (this.checkedIds.length==0) {
      this.screenValidity.errorMessages.push('Msg_Preciser_coeur_de_metier');
      isValid=false;
    }
    if (this.FamiliesTooManySel()){
      this.screenValidity.errorMessages.push('Msg_limiter_domaine_activite');
      isValid=false;      
    }
    let supplierKnowledgeParameters: SupplierKnowledgeParameters = new SupplierKnowledgeParameters();
    supplierKnowledgeParameters.SupplierAnswers = this.supplier.SupplierAnswers;
    supplierKnowledgeParameters.SupplierAnswers = supplierKnowledgeParameters.SupplierAnswers.filter(a => this.visibleQuestions.some(vQuestion => vQuestion.Id == a.QuestionId));
    supplierKnowledgeParameters.SupplierAnswers.forEach(a => a.SupplierId = this.supplier.Id);
    if (!this.checkAnswerComplete(supplierKnowledgeParameters)) {
      this.screenValidity.errorMessages.push('Msg_Completer_Specificites');
      isValid = false;
    }
    return of(isValid);
  }


  private checkAnswerComplete(parameters: SupplierKnowledgeParameters): boolean {
    if (!parameters.SupplierAnswers) return false;
    return !parameters.SupplierAnswers.some(a => !this._answerComplete(a));
  }

  //Un reponse est incomplète si elle est nulle et qu'il existe une question parent à laquelle une réponse a été donnée et a induit l'affichage de cette question
  private _answerComplete(suppAnswer: SupplierAnswer) {
    if (!suppAnswer) return false;
    if (suppAnswer.Answer == null && this.firstLevelQuestions.some(q => q.Id == suppAnswer.QuestionId)) {
      return false;
    } else {
      return !((suppAnswer.Answer == null)
        && this.supplier.SupplierAnswers
          .some(sa => (sa.Answer == 1 && sa.Question.IdTrueQuestion == suppAnswer.QuestionId)
            || (sa.Answer == 0 && sa.Question.IdFalseQuestion == suppAnswer.QuestionId)));

    }
  }

  get showAccidentologie(): boolean {
    return this.supplier.SupplierAnswers.some(a => a.Answer == 1 && a.Question?.Cod == "TOP_INTERVENTION_SITE")
      && (this.PrestationTravauxSel() || this.RessourcesHumainesSel());
  }


  deleteSelectedFamily(familyId: number): void {
    this._deleteSelectedFamilyRecurs(familyId);
    this.checkedIds = this.selectedSupplierFamilies.filter(sf => sf.Family.ParentId != null).map(sf => sf.FamilyId);
  }


  private _deleteSelectedFamilyRecurs(familyId: number): void {
    this.selectedSupplierFamilies.filter(f => f.Family.ParentId == familyId)
      .forEach((sf: SupplierFamily) => this._deleteSelectedFamilyRecurs(sf.FamilyId));
    this.selectedSupplierFamilies = this.selectedSupplierFamilies.filter(sf => sf.FamilyId != familyId);

  }

  public isTreeActivitDomainyDisabled = (dataItem: any) => {
    return this.domaineActiviteDisabled || !this.isEditing();
  }

}
